import { render, staticRenderFns } from "./NotificationBase.vue?vue&type=template&id=57f66764&"
import script from "./NotificationBase.vue?vue&type=script&lang=js&"
export * from "./NotificationBase.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VSnackbar})
